import * as React from "react";
import { useHistory } from "react-router";
import { Stepper, Step, StepButton, Button, CardContent, Paper, CardActions, Typography, Box, Grid, Chip  } from "@mui/material";
import { MdCheckCircle } from "react-icons/md";
import { PatientData } from "../Contexts";
import * as CONST from "../Constants";
import * as API from "../api";
import Flash from "../layout/Flash";
import Loading from "../../../shared/Loading";

export default function AnnualWellnessVisitPage({year}) {
  const patient = React.useContext(PatientData);
  let body = year == '2025' ? patient.annual_wellness_visit_module_2025.body : patient.annual_wellness_visit_module.body;

  return(<>
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={12} className="module" px={2} color="#1a237e">
        <div>
          <Typography variant="h3" component="div" lineHeight={1.1} color="#1a237e">
          </Typography>
          <Box
            fontWeight={300}
            color="#1a237e"
            dangerouslySetInnerHTML={{
              __html: body
            }}
          />
        </div>
      </Grid>
    </Grid>
  </>);
}
